import { useState } from "react";
import { KeyRound, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function ChangePasswordDialog({ open, onClose, dark = false }) {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (form.new_password !== form.confirm) { toast.error("New passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password changed successfully");
      setForm({ current_password: "", new_password: "", confirm: "" });
      onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const inputCls = dark
    ? "border-slate-700 bg-slate-900 text-slate-100 placeholder:text-slate-600"
    : "border-slate-200 bg-white text-[#0F2440]";
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className={dark ? "border-slate-800 bg-[#111827] text-slate-100" : "border-slate-200 bg-white text-[#0F2440]"}>
        <DialogHeader><DialogTitle>Change password</DialogTitle></DialogHeader>
        <div className="space-y-3">
          {[["current_password", "Current password"], ["new_password", "New password (min 8 chars)"], ["confirm", "Confirm new password"]].map(([k, label]) => (
            <div key={k}>
              <p className={`mb-1 text-[10px] font-semibold uppercase tracking-wider ${dark ? "text-slate-500" : "text-slate-400"}`}>{label}</p>
              <div className="relative">
                <Input data-testid={`cp-${k}`} type={show ? "text" : "password"} value={form[k]}
                  onChange={(e) => setForm({ ...form, [k]: e.target.value })} className={`${inputCls} pr-9`} autoComplete="off" />
                {k === "current_password" && (
                  <button type="button" data-testid="cp-toggle" onClick={() => setShow(!show)}
                    className={`absolute right-2.5 top-1/2 -translate-y-1/2 ${dark ? "text-slate-500" : "text-slate-400"}`}>
                    {show ? <EyeOff size={14} /> : <Eye size={14} />}
                  </button>
                )}
              </div>
            </div>
          ))}
          <Button data-testid="cp-submit" onClick={submit}
            disabled={busy || !form.current_password || form.new_password.length < 8 || !form.confirm}
            className="w-full bg-[#FF6B00] font-semibold text-white hover:bg-[#E85D04]">
            <KeyRound size={13} /> {busy ? "Updating…" : "Update password"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
